import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface Vendor {
  id: number;
  vendorNumber: string;
  name: string;
}
export interface Plant {
  id: number;
  plantNumber: string;
  name: string;
}
export interface Reason {
  id: number;
  label: string;
}
export interface ErpSystem {
  id: number;
  name: string;
}

export function useVendors() {
  return useQuery({ queryKey: ["ref", "vendors"], queryFn: () => api.get<{ rows: Vendor[] }>("/reference/vendors").then((r) => r.rows) });
}
export function usePlants() {
  return useQuery({ queryKey: ["ref", "plants"], queryFn: () => api.get<{ rows: Plant[] }>("/reference/plants").then((r) => r.rows) });
}
export function useReasons() {
  return useQuery({ queryKey: ["ref", "reasons"], queryFn: () => api.get<{ rows: Reason[] }>("/reference/reasons").then((r) => r.rows) });
}
export function useErpSystems() {
  return useQuery({ queryKey: ["ref", "erp-systems"], queryFn: () => api.get<{ rows: ErpSystem[] }>("/reference/erp-systems").then((r) => r.rows) });
}
